module.exports = __webpack_public_path__ + "static/media/credit.2a67c1d6.jpg";